export const ServiceType = {
  Legal: "Legal Services",
  Accounting: "Accounting",
  "Investment Banking": "Investment Banking",
  Other: "Other"
} as const;

export const MembershipType = {
  Primary: "Primary",
  Regional: "Regional",
  Multiple: "Multiple Primary",
} as const;

export const MembershipStatus = {
  Member: "Member",
  Accepted: "Accepted",
  TemporaryWithdrawn: "Temporary Withdrawn",
  Withdrawn: "Withdrawn",
  Onboarding: "Onboarding"
} as const;

export const FirmType = {
  legal: "Legal",
  office: "Office",
  venue: "Venue",
} as const;

export type ServiceTypeEnum = keyof typeof ServiceType;
export type MembershipTypeEnum = keyof typeof MembershipType;
export type MembershipStatusEnum = keyof typeof MembershipStatus;
export type FirmTypeEnum = keyof typeof FirmType;